import React from 'react';
import moment from 'moment';
import TableBoolean from '../../components/Table/TableBoolean/TableBoolean';

const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns = [
    {
        dataField: 'IsActive',
        text: 'Status',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => <TableBoolean value={row.IsActive === true} text={row.IsActive=== true ? 'Active' : 'Inactive'} />,
    },
    {
        dataField: 'MailMergeCategory.Name',
        text: 'Category',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'Name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'MediaType.Name',
        text: 'Media Type',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'CreatedOn',
        text: 'Created On',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => {
            return moment(row.CreatedOn).format('MM/DD/YYYY hh:mm A')
        }
    }
];

export const sorting = [{
    dataField: 'MailMergeCategory.Name',
    order: 'asc'
}];